import loginForm from "../views/auth/login";
import home from "../views/auth/home";
import faCategory from "../views/facility_management/masters/faCategory";
import faSubCategory from "../views/facility_management/masters/faSubCategory";
import IO from "socket.io-client";
import { baseUrl } from "./url";
import assetLocation from "../views/facility_management/masters/assetLocation";
import assetSubLocation from "../views/facility_management/masters/assetSubLocation";
import buildingAssets from "../views/facility_management/masters/buildingAssets";
import employeeRates from "../views/facility_management/masters/employeeRates";
import complaintType from "../views/facility_management/masters/complaintType";
import complaintStatus from "../views/facility_management/masters/complaintStatus";
import complaintSource from "../views/facility_management/masters/complaintSource";
import maintenanceTeam from "../views/facility_management/masters/maintenanceTeam";
import jobRegistration from "../views/facility_management/complaints/registration";
import jobSearch from "../views/facility_management/complaints/search";
import EmailTemplate from "../views/facility_management/masters/emailTemplate";

import {
  ApartmentOutlined,
  BankOutlined,
  BranchesOutlined,
  CheckSquareOutlined,
  ClusterOutlined,
  ContainerOutlined,
  DashboardOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  ExceptionOutlined,
  FileAddOutlined,
  FileExclamationOutlined,
  FileOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FileUnknownOutlined,
  ForkOutlined,
  FundOutlined,
  GlobalOutlined,
  GoldOutlined,
  HomeOutlined,
  InsertRowBelowOutlined,
  MailOutlined,
  OrderedListOutlined,
  StockOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import materialCategory from "../views/facility_management/masters/materialCategory";
import materialItem from "../views/facility_management/masters/materialItem";
import project from "../views/facility_management/masters/project";
import building from "../views/facility_management/masters/building";
import unit from "../views/facility_management/masters/unit";
import company from "../views/facility_management/masters/company";
import contact from "../views/facility_management/masters/contact";
import unitHandoverVacatingStatus from "../views/facility_management/masters/unitVacatingHandoverStatus";
import unitHandoverVacatingChecklist from "../views/facility_management/masters/unitVacatingHandoverChecklist";
import unitVacatingHandoverView from "../views/facility_management/masters/unitVacatingHandoverList";
import unitVacatingHandover from "../views/facility_management/masters/unitVacatingHandover";
import employeeAttendance from "../views/payroll/employeeAttendance";

export const tokenKey = "Biz_FM";
export let encodedToken = { value: null };
export let decodedToken = { value: null };
export const socket = IO(baseUrl);

export const theRoutes = [
  {
    key: "login",
    name: "login",
    path: "/login",
    component: loginForm,
    for: ["employee", "tenant"],
  },
  {
    key: "dashboard",
    name: "Dashboard",
    path: "/dashboard",
    component: home,
    for: ["employee", "tenant"],
  },
  // {
  //   key: "masterProject",
  //   name: "Project",
  //   path: "/masterProject",
  //   form_name_id: 34,
  //   form_name: "frmProject",
  //   component: project,
  //   for: ["employee"],
  // },
  // {
  //   key: "masterBuilding",
  //   name: "Building",
  //   path: "/masterBuilding",
  //   form_name_id: 35,
  //   form_name: "frmBuilding",
  //   component: building,
  //   for: ["employee"],
  // },
  // {
  //   key: "masterUnit",
  //   name: "Unit",
  //   path: "/masterUnit",
  //   form_name_id: 36,
  //   form_name: "frmUnit",
  //   component: unit,
  //   for: ["employee"],
  // },
  // {
  //   key: "masterCompany",
  //   name: "Company",
  //   path: "/masterCompany",
  //   form_name_id: 32,
  //   form_name: "frmCompany",
  //   component: company,
  //   for: ["employee"],
  // },
  // {
  //   key: "masterContact",
  //   name: "Contact",
  //   path: "/masterContact",
  //   form_name_id: 33,
  //   form_name: "frmContact",
  //   component: contact,
  //   for: ["employee"],
  // },
  // {
  //   key: "handoverVacatingStatus",
  //   name: "Handover Vacating Status",
  //   path: "/handoverVacatingStatus",
  //   form_name_id: 167,
  //   form_name: "frmHandoverVacatingStatus",
  //   component: unitHandoverVacatingStatus,
  //   for: ["employee"],
  // },
  // {
  //   key: "handoverVacatingChecklist",
  //   name: "Handover Vacating Checklist",
  //   path: "/handoverVacatingChecklist",
  //   form_name_id: 166,
  //   form_name: "frmHandoverVacatingCheckListMaster",
  //   component: unitHandoverVacatingChecklist,
  //   for: ["employee"],
  // },
  // {
  //   key: "handoverVacatingView",
  //   name: "Handover Vacating List",
  //   path: "/handoverVacatingView",
  //   form_name_id: 74,
  //   form_name: "frmUnitHandoverVacating",
  //   component: unitVacatingHandoverView,
  //   for: ["employee"],
  // },
  // {
  //   key: "handoverVacating",
  //   name: "Handover Vacating",
  //   path: "/handoverVacating",
  //   form_name_id: 74,
  //   form_name: "frmUnitHandoverVacating",
  //   component: unitVacatingHandover,
  //   for: ["employee"],
  // },
  // {
  //   key: "maintenanceTeam",
  //   name: "Maintenance Team",
  //   path: "/maintenanceTeam",
  //   form_name_id: 55,
  //   form_name: "frmMaintenanceTeam",
  //   component: maintenanceTeam,
  //   for: ["employee"],
  // },
  // {
  //   key: "faCategory",
  //   name: "FA Category",
  //   path: "/faCategory",
  //   form_name_id: 56,
  //   form_name: "frmFMFACategory",
  //   component: faCategory,
  //   for: ["employee"],
  // },
  // {
  //   key: "faSubCategory",
  //   name: "FA Sub Category",
  //   path: "/faSubCategory",
  //   form_name_id: 57,
  //   form_name: "frmFMFASubCategory",
  //   component: faSubCategory,
  //   for: ["employee"],
  // },
  // {
  //   key: "materialCategory",
  //   name: "Material Category",
  //   path: "/materialCategory",
  //   form_name_id: 57,
  //   form_name: "frmFMFASubCategory",
  //   component: materialCategory,
  //   for: ["employee"],
  // },
  // {
  //   key: "materialItem",
  //   name: "Material Item",
  //   path: "/materialItem",
  //   form_name_id: 57,
  //   form_name: "frmFMFASubCategory",
  //   component: materialItem,
  //   for: ["employee"],
  // },
  // {
  //   key: "assetLocation",
  //   name: "Asset Location",
  //   path: "/assetLocation",
  //   form_name_id: 58,
  //   form_name: "frmAssetLocation",
  //   component: assetLocation,
  //   for: ["employee"],
  // },
  // {
  //   key: "assetSubLocation",
  //   name: "Assets Sub Location",
  //   path: "/assetSubLocation",
  //   form_name_id: 59,
  //   form_name: "frmAssetSubLocation",
  //   component: assetSubLocation,
  //   for: ["employee"],
  // },
  // {
  //   key: "buildingAssets",
  //   name: "Building Assets",
  //   path: "/buildingAssets",
  //   form_name_id: 60,
  //   form_name: "frmPMBuildingAssets",
  //   component: buildingAssets,
  //   for: ["employee"],
  // },
  // {
  //   key: "employeeRate",
  //   name: "Employee Rate",
  //   path: "/employeeRate",
  //   form_name_id: 61,
  //   form_name: "frmFMEmployeeRate",
  //   component: employeeRates,
  //   for: ["employee"],
  // },
  // {
  //   key: "complaintTypes",
  //   name: "Complaint Types",
  //   path: "/complaintTypes",
  //   form_name_id: 62,
  //   form_name: "frmRentalComplaintType",
  //   component: complaintType,
  //   for: ["employee"],
  // },
  // // {
  // //   key: "complaintCategory",
  // //   name: "Complaint Category",
  // //   path: "/complaintCategory",
  // //   form_name_id: 63,
  // //   form_name: "frmRentalComlaintCategory",
  // //   component: ComplaintCategory,
  // // },
  // {
  //   key: "complaintStatus",
  //   name: "Complaint Status",
  //   path: "/complaintStatus",
  //   form_name_id: 63,
  //   form_name: "frmRentalComlaintStatus",
  //   component: complaintStatus,
  //   for: ["employee"],
  // },
  // {
  //   key: "complaintSource",
  //   name: "Complaint Source",
  //   path: "/complaintSource",
  //   form_name_id: 64,
  //   form_name: "frmPMProblemOrigin",
  //   component: complaintSource,
  //   for: ["employee"],
  // },
  {
    key: "jobRegistration",
    name: "Registration",
    path: "/jobRegistration",
    form_name_id: 65,
    form_name: "frmFMJob_step1",
    component: jobRegistration,
    for: ["employee"],
  },
  // {
  //   key: "jobAssignmentClosing",
  //   name: "Job Assignment & Closing",
  //   path: "/jobAssignmentClosing",
  //   form_name_id: 65,
  //   form_name: "frmFMJob_step1",
  //   component: JobAssignmentClosing,
  // },
  {
    key: "jobSearch",
    name: "Search",
    path: "/jobSearch",
    form_name_id: 69,
    form_name: "frmRentalComplaintSearch",
    component: jobSearch,
    for: ["employee"],
  },
  // {
  //   key: "payrollEmloyeeAttendance",
  //   name: "Employee Attendance",
  //   path: "/payrollEmloyeeAttendance",
  //   form_name_id: 69,
  //   form_name: "frmEmpAttendance",
  //   component: employeeAttendance,
  //   for: ["employee"],
  // },
  // {
  //   key: "emailTemplate",
  //   name: "Email Template",
  //   path: "/emailTemplate",
  //   form_name_id: 69,
  //   form_name: "frmRentalComplaintSearch",
  //   component: EmailTemplate,
  //   for: ["employee"],
  // },
];

export const theSubMenu = [
  {
    key: "home",
    title: "Home",
    // for: ["tenant"],
    for: ["employee", "tenant"],
    icon: <HomeOutlined />,
    childs: [
      {
        key: "dashboard",
        title: "Dashboard",
        for: ["employee", "tenant"],
        icon: <DashboardOutlined />,
      },
    ],
  },
  // {
  //   key: "entity",
  //   title: "Entity",
  //   for: ["employee"],
  //   icon: <ApartmentOutlined />,
  //   childs: [
  //     {
  //       key: "masterCompany",
  //       title: "Company",
  //       for: ["employee"],
  //       icon: <BankOutlined />,
  //     },
  //     {
  //       key: "masterContact",
  //       title: "Contacts",
  //       for: ["employee"],
  //       icon: <TeamOutlined />,
  //     },
  //   ],
  // },
  // {
  //   key: "property",
  //   title: "Property",
  //   for: ["employee"],
  //   icon: <ClusterOutlined />,
  //   childs: [
  //     {
  //       key: "masterProject",
  //       title: "Project",
  //       for: ["employee"],
  //       icon: <BranchesOutlined />,
  //     },
  //     {
  //       key: "masterBuilding",
  //       title: "Building",
  //       for: ["employee"],
  //       icon: <BankOutlined />,
  //     },
  //     {
  //       key: "masterUnit",
  //       title: "Unit",
  //       for: ["employee"],
  //       icon: <ForkOutlined />,
  //     },
  //   ],
  // },
  // {
  //   key: "facilityManagement",
  //   title: "Facility Management",
  //   for: ["employee"],
  //   icon: <InsertRowBelowOutlined />,
  //   childs: [
  //     {
  //       key: "handoverVacatingSection",
  //       title: "Handover/Vacating",
  //       for: ["employee"],
  //       icon: <ContainerOutlined />,
  //       childs: [
  //         {
  //           key: "handoverVacatingStatus",
  //           title: "Status",
  //           for: ["employee"],
  //           icon: <FileExclamationOutlined />,
  //         },
  //         {
  //           key: "handoverVacatingChecklist",
  //           title: "Checklist",
  //           for: ["employee"],
  //           icon: <CheckSquareOutlined />,
  //         },
  //         {
  //           key: "handoverVacatingView",
  //           title: "Handover Vacating List",
  //           for: ["employee"],
  //           icon: <OrderedListOutlined />,
  //         },
  //         {
  //           key: "handoverVacating",
  //           title: "Handover Vacating",
  //           for: ["employee"],
  //           icon: <FileOutlined />,
  //         },
  //       ],
  //     },
  // {
  //   key: "employee",
  //   title: "Employee",
  //   for: ["employee"],
  //   icon: <UserOutlined />,
  //   childs: [
  //     {
  //       key: "maintenanceTeam",
  //       title: "Maintenance Team",
  //       for: ["employee"],
  //       icon: <TeamOutlined />,
  //     },
  //     {
  //       key: "employeeRate",
  //       title: "Rate",
  //       for: ["employee"],
  //       icon: <DollarOutlined />,
  //     },
  //   ],
  // },
  //     {
  //       key: "fa",
  //       title: "Assets",
  //       for: ["employee"],
  //       icon: <StockOutlined />,
  //       childs: [
  //         {
  //           key: "faCategory",
  //           title: "Category",
  //           for: ["employee"],
  //           icon: <OrderedListOutlined />,
  //         },
  //         {
  //           key: "faSubCategory",
  //           title: "Sub Category",
  //           for: ["employee"],
  //           icon: <UnorderedListOutlined />,
  //         },
  //       ],
  //     },
  // {
  //   key: "material",
  //   title: "Material",
  //   for: ["employee"],
  //   icon: <FundOutlined />,
  //   childs: [
  //     {
  //       key: "materialCategory",
  //       title: "Category",
  //       for: ["employee"],
  //       icon: <OrderedListOutlined />,
  //     },
  //     {
  //       key: "materialItem",
  //       title: "Item",
  //       for: ["employee"],
  //       icon: <UnorderedListOutlined />,
  //     },
  //   ],
  // },
  //     {
  //       key: "building",
  //       title: "Building",
  //       for: ["employee"],
  //       icon: <BankOutlined />,
  //       childs: [
  //         {
  //           key: "assetLocation",
  //           title: "Asset Location",
  //           for: ["employee"],
  //           icon: <GlobalOutlined />,
  //         },
  //         {
  //           key: "assetSubLocation",
  //           title: "Asset Sub Location",
  //           for: ["employee"],
  //           icon: <EnvironmentOutlined />,
  //         },
  //         {
  //           key: "buildingAssets",
  //           title: "Assets",
  //           for: ["employee"],
  //           icon: <GoldOutlined />,
  //         },
  //       ],
  //     },
  //     {
  //       key: "complaint",
  //       title: "Complaint",
  //       for: ["employee"],
  //       icon: <ExceptionOutlined />,
  //       childs: [
  //         {
  //           key: "complaintTypes",
  //           title: "Types",
  //           for: ["employee"],
  //           icon: <FileTextOutlined />,
  //         },
  //         {
  //           key: "complaintStatus",
  //           title: "Status",
  //           for: ["employee"],
  //           icon: <FileExclamationOutlined />,
  //         },
  //         {
  //           key: "complaintSource",
  //           title: "Source",
  //           for: ["employee"],
  //           icon: <FileUnknownOutlined />,
  //         },
  //       ],
  //     },
  // {
  //   key: "job",
  //   title: "Job",
  //   for: ["employee"],
  //   icon: <FileTextOutlined />,
  //   childs: [
  //     {
  //       key: "jobRegistration",
  //       title: "Registration",
  //       for: ["employee"],
  //       icon: <FileAddOutlined />,
  //     },
  //     {
  //       key: "jobSearch",
  //       title: "Search",
  //       for: ["employee"],
  //       icon: <FileSearchOutlined />,
  //     },
  //   ],
  // },
  //   ],
  // },
  {
    key: "jobRegistration",
    title: "Registration",
    for: ["employee"],
    icon: <FileAddOutlined />,
  },
  {
    key: "jobSearch",
    title: "Search",
    for: ["employee"],
    icon: <FileSearchOutlined />,
  },
  // {
  //   key: "payrollEmloyeeAttendance",
  //   title: "Employee Attendance",
  //   for: ["employee"],
  //   icon: <FileSearchOutlined />,
  // },
  // {
  //   key: "emailTemplate",
  //   title: "Email Template",
  //   for: ["employee"],
  //   icon: <MailOutlined />,
  // },
];

export const stateStore = {
  permissions: {},
  navAble: null,
  setStateJobReference: null,
};
